var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_3454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.532715 9.04377V22.1143C0.532715 22.86 1.13991 23.4672 1.88558 23.4672H7.92552V14.9772H14.4342V23.4672H20.4741C21.2198 23.4672 21.827 22.86 21.827 22.1143V9.04377C21.827 8.62832 21.6352 8.23418 21.305 7.97852L12.0054 0.809412C11.5154 0.436576 10.8443 0.436576 10.3543 0.809412L1.05469 7.96787C0.724459 8.22353 0.532715 8.61767 0.532715 9.03311V9.04377Z",
    stroke: "#3A77BC",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0386 7.09473H9.29956V10.6313H13.0386V7.09473Z",
    stroke: "#B4D334",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_3454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3595,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.78e9527d497a46af43a22f531b6fe346.svg";
export { ForwardRef as ReactComponent };